import { ModoDoBrinde } from '../generated/backend-enums.js';
export { ModoDoBrinde };
export const ModoDoBrindeMap = {
    [ModoDoBrinde.IGUAL_PARA_TODOS]: 'O mesmo gift para todos',
    [ModoDoBrinde.PERSONALIZADO]: 'Um gift diferente para cada contato',
};
